import { ReactNode } from 'react';
import { nbsp } from '../index';

export default function (children: ReactNode) {
    return typeof children === 'string' ? nbsp(children) : children;
}
